import React, { useState, useRef, useEffect } from 'react';

import './ContactLensDetails.scss';

export const ContactLensDetails = props => {
  const { data } = props;
  const { productId, model, material, baseWidth, diameter } = data;

  const [isExpanded, setIsExpanded] = useState(true);
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('0px');

  useEffect(() => {
    if (isExpanded && contentRef.current) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setTimeout(() => setMaxHeight('0px'), 10);
    }
  }, [isExpanded]);

  const renderInfoItem = (title, value) => {
    return (
      <div className="contact-lens-details__info__item">
        <p>{title}</p>
        <p>{value}</p>
      </div>
    );
  };

  return (
    <div className="contact-lens-details">
      <div className="contact-lens-details__container">
        <h3
          className="contact-lens-details__title"
          data-is-expanded={isExpanded}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          Lens Details
        </h3>

        {isExpanded && (
          <div
            ref={contentRef}
            className="contact-lens-details__expanded-content"
            style={{ maxHeight }}
          >
            <div className="contact-lens-details__info">
              {renderInfoItem('Product ID', productId)}
              {renderInfoItem('Model', model)}
              {renderInfoItem('Material', material)}
              {renderInfoItem('Base Width', `${baseWidth} mm`)}
              {renderInfoItem('Diameter', `${diameter} mm`)}
            </div>

            <button className="contact-lens-details__more-button">+7 more Details</button>
          </div>
        )}
      </div>
    </div>
  );
};
